export default __webpack_public_path__ + "static/club_outline@2x-06586c45d44b802987fb27fd28ccdac3.png";